export function askPermission() {
  return new Promise((resolve, reject) => {
    const permissionResult = Notification.requestPermission((result) => {
      resolve(result)
    })

    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    if (permissionResult) {
      permissionResult.then(resolve, reject)
    }
  })
}

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4)
  // eslint-disable-next-line no-useless-escape
  const base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/')

  const rawData = window.atob(base64)
  const outputArray = new Uint8Array(rawData.length)

  for (let i = 0; i < rawData.length; i += 1) {
    outputArray[i] = rawData.charCodeAt(i)
  }

  return outputArray
}

export function subscribeUserToPush() {
  return navigator.serviceWorker
    .register('/sw.js')
    .then((registration) => {
      const subscribeOptions = {
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(
          process.env.NEXT_PUBLIC_KEY_PUSH_NOTIFICATION
        )
      }

      return registration.pushManager.subscribe(subscribeOptions)
    })
    .then((pushSubscription) => {
      return pushSubscription
    })
}
